import styled from '@emotion/styled'
import Divider from '@mui/material/Divider'

const DividerWithMargin = styled(Divider)`
  margin: 4px 0;
`

export const MenuItemDivider = ({ variant = 'middle', ...props }) => (
  <DividerWithMargin variant={variant} {...props} />
)
